import { authAction } from "../context/auth";
import service from "../services/service";
import { getAccStatus, getUserAccounts } from "./acc_actions";

export const login =
  (accessToken, navigate, accountId = null) =>
  async (dispatch) => {
    console.group("🔐 LOGIN FLOW");

    try {
      console.log("Starting login...");

      // --------------------------------------------------
      // Accept invitation (if exists)
      // --------------------------------------------------
      const invitationToken = localStorage.getItem("invitation_token");

      if (invitationToken) {
        console.log("Invitation token found.");

        const inviteRes = await service.acceptInvite({
          invite_token: invitationToken,
          access_token: accessToken,
        });

        if (!inviteRes?.data?.body) {
          throw new Error("Failed to accept invitation.");
        }

        localStorage.removeItem("invitation_token");
        console.log("Invitation accepted.");
      }

      // --------------------------------------------------
      // Sign in
      // --------------------------------------------------
      const signinRes = await service.signin({
        exchange_token: accessToken,
        client_id: "magic-stamp",
        include_refresh_token: true,
      });

      const authData = signinRes?.data?.body;

      console.log("Authentication response:", authData);

      if (!authData?.access_token) {
        throw new Error("Invalid authentication response.");
      }

      dispatch(
        authAction({
          type: "LOGIN_SUCCESS",
          data: authData,
        }),
      );

      console.log("Authentication successful.");

      // --------------------------------------------------
      // Load accounts
      // --------------------------------------------------
      console.log("Loading accounts...");

      const accounts = await dispatch(getUserAccounts());

      console.log("Accounts response:", accounts);

      // --------------------------------------------------
      // Resolve active account
      // --------------------------------------------------
      let selectedAccount = null;

      if (accountId && Array.isArray(accounts)) {
        selectedAccount =
          accounts.find(
            (a) =>
              a.id === accountId ||
              a.accountId === accountId ||
              a.urn === accountId,
          ) ?? null;
      }

      if (!selectedAccount) {
        const stored = localStorage.getItem("userAccount");

        if (stored) {
          try {
            selectedAccount = JSON.parse(stored);
          } catch {
            console.warn("Invalid stored account.");
          }
        }
      }

      if (!selectedAccount && Array.isArray(accounts) && accounts.length) {
        selectedAccount = accounts[0];
      }

      if (!selectedAccount?.urn) {
        throw new Error("No account selected.");
      }

      console.log("Active account:", selectedAccount);

      // --------------------------------------------------
      // Account status
      // --------------------------------------------------
      const statusRes = await getAccStatus(selectedAccount.urn);

      const account = statusRes?.data;

      if (!account) {
        throw new Error("Unable to load account status.");
      }

      const completedSteps = [
        Number(account.businessesCount) > 0,
        Number(account.outletsCount) > 0,
        Number(account.rewardsCount) > 0,
        Number(account.stampcardsCount) > 0,
      ].filter(Boolean).length;

      const isOnboardingComplete = completedSteps === 4;

      console.table({
        businesses: account.businessesCount,
        outlets: account.outletsCount,
        rewards: account.rewardsCount,
        stampcards: account.stampcardsCount,
        completedSteps,
      });

      console.log(
        `Navigating to ${isOnboardingComplete ? "/home" : "/overview"}`,
      );

      navigate(isOnboardingComplete ? "/home" : "/overview");

      return authData;
    } catch (error) {
      console.error("❌ Login failed");

      console.error({
        message: error.message,
        status: error.response?.status,
        response: error.response?.data,
        stack: error.stack,
      });

      dispatch(
        authAction({
          type: "LOGIN_FAILURE",
          error,
        }),
      );

      throw error;
    } finally {
      console.groupEnd();
    }
  };

export const signout = () => (dispatch) => {
  // Clear all local storage
  localStorage.clear();

  // Dispatch logout action
  dispatch(
    authAction({
      type: "LOGOUT",
    }),
  );
};
